
import FindPartner from "../../components/landing/search-on-dating-sites/find-partner";
import QuotesBlock from "../../components/landing/search-on-dating-sites/quotes-block";
import blog from "../../components/landing/blog";
import ServiceFor from "../../components/landing/search-on-dating-sites/service-for";
import HowWeDo from "../../components/landing/search-on-dating-sites/how-we-do";
import SitesScan from "../../components/landing/search-on-dating-sites/sites-scan";
import Waiting from "../../components/landing/search-on-dating-sites/waiting";
const Results = ()=> import  ("../../components/landing/search-on-dating-sites/results");
import Steps from "../../components/landing/search-on-dating-sites/steps";
import RealStories from "../../components/landing/search-on-dating-sites/real-stories.vue";
import Featured from "../../components/landing/search-on-dating-sites/featured";
import Mission from "../../components/landing/search-on-dating-sites/mission";
import AlreadyUsing from "../../components/landing/search-on-dating-sites/already-using";
import Comments from "../../components/landing/search-on-dating-sites/comments";
import Overcoming from "../../components/landing/search-on-dating-sites/overcoming";
import Faq from "../../components/landing/search-on-dating-sites/faq";
import QuotesBlockKnowledge from "../../components/landing/search-on-dating-sites/quotes-block-knowledge";
import Navigation from '../../components/Navigation.vue';
import FooterMain from '../../components/FooterMain.vue';


import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";

export default {
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    QuotesBlock,
    blog,
    ServiceFor,
    HowWeDo,
    SitesScan,
    Waiting,
    Results,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },

  head() {
    const title = 'Discover Infidelity: Find Spouse Cheating on Dating Sites | iFindCheaters';
    const description = 'Find hidden profiles of your cheating spouse, husband, wife, or girlfriend on dating apps. Discover iFindCheaters for quick scans on dating sites to catch cheaters. Uncover profiles on dating apps using just an email. Start your search today!';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { hid:'og:title', property: 'og:title', content: title },
        { hid: "description", name: "description", content: description },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Find Spouse Cheating, search for spouse on dating sites, cheaters dating sites, dating website for cheating, search hidden dating profiles, find cheating partner, ‎find someone on dating sites by email, how to find someone on dating sites, how to find my husband on dating sites, search dating sites by email'
        },
        { hid: "og:description", name: "og:description", content: description },
        { hid: 'og:image',  property: 'og:image', content: '/products/find-someone-cheating-online-for-free/og.png' },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid:'title', property: 'title', content: 'Find spouse on dating sites ᐈ Product of iFindCheaters' },
        { hid:'og:site_name', property: 'og:site_name', content: 'ifindcheaters.com' },
        { hid: 'og:keywords', name: 'og:keywords', content: 'secret profile finder, search people on dating sites, search for someone on dating sites, search dating profiles, is my husband on dating sites, find hidden dating profiles, find my wife on dating sites, catch a cheating spouse, find spouse on dating sites, Catch cheating partner online, Online infidelity search, find out if my boyfriend or girlfriend is on dating sites, how to find spouse on dating sites, is my wife on dating sites or apps, free dating profiles search by email' }
      ],
      link: [

        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/search-on-dating-sites/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Find Your Partner On Dating Sites"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Find Your Partner On Dating Sites",
            "sku": "002",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": description,
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/search-on-dating-sites/",
              "priceCurrency": "USD",
              "price": "9.99",
              "priceValidUntil": "2022-05-25",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "JudiAngel82"
              },
              "datePublished": "2021-06-07T18:08:30+00:00",
              "reviewBody": "I was devastated when I saw he had active accounts but we talked it out and our relationship is better today. it's the best site to catch a cheater."
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4.5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Sara1974"
              },
            "datePublished": "2020-11-12T14:35:29+00:00",
            "reviewBody": "He just seemed different all of a sudden. There wasn’t one specific thing I could my finger on. When she started not picking up calls a friend sent me the link. It was really hard when I first saw the report, at least I knew I wasn’t crazy."
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.5",
              "reviewCount": "74"
              }
            }
          }
      ]
    }
  },


};
